<template>
  <div>
    <button v-if="action.function" @click="action.function(row)">
      {{ action.label }}
    </button>
    <router-link
      v-else
      tag="button"
      :to="{ name: action.name, params: getActionParam(action, row) }"
    >
      {{ action.label }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'DataTableAction',
  props: {
    row: Object,
    action: Object
  },
  methods: {
    getActionParam(action, row) {
      let params = {}
      for (var key in action.params) {
        params[action.params[key]] = row[key]
      }
      return params
    }
  }
}
</script>
